// @flow
/* eslint-disable */
import React from 'react';
import classnames from 'classnames';
import PlayingCard from '../../../components/PlayingCard';
import Icon from '../../../components/Icon';
import { sortCards } from '../../../utils/game/sortRandomCards';
import styles from './styles.module.scss';

type Props = {
  setSelectedCards: () => void,
  selectedCards: Array<any>,
  selectedBoard: Array<any>,
  nonSuitCardSelected: boolean,
  cardColor: string,
  heroColor: string,
  isPlo5?: boolean,
  clearCards: () => void,
};

const cardsComb = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
// const customColor = 'linear-gradient(180deg, #FF7B73 0%, #B04747 100%)'

const CardChooser = ({
  setSelectedCards,
  selectedCards,
  selectedBoard,
  nonSuitCardSelected,
  cardColor,
  heroColor,
  isPlo5,
  clearCards,
}: Props) => {
  const firstComb = cardsComb.join('h') + 'h'
  const secondComb = cardsComb.join('s') + 's'
  const thirdComb = cardsComb.join('d') + 'd'
  const fourthComb = cardsComb.join('c') + 'c'
  const fifthComb = cardsComb.join('x') + 'x'

  const customColor = () => {
    switch (cardColor) {
      case 'red': {
        return 'linear-gradient(180deg, #FF7B73 0%, #B04747 100%)'
      }
      case 'blue': {
        return 'linear-gradient(151.11deg, #4991B7 0%, #14425C 100%)'
      }
      case 'green': {
        return 'linear-gradient(180.36deg, #70A74A 0.31%, #4B7B27 99.69%)'
      }
      case '' : {
        return 'linear-gradient(180deg, #FF7B73 0%, #B04747 100%)'
      }
    }
  }

  const cardIsSelected = (item) => {
    if (nonSuitCardSelected) {
      if (item[1] === 'x') {
        if (selectedCards.includes(item[0] + item[1])) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }

    if (selectedCards.length > 0 && item[1] === 'x') {
      return true
    }

    if (selectedBoard.includes(item[0] + item[1])) {
      return true
    }
    return selectedCards.includes(item[0] + item[1])
  }

  const getXSuit = (item) => {
    if (item.length === 1) {
      return 'x'
    } else {
      return item[1]
    }
  }

  const getSuit = (item) => {
    if (cardIsSelected(item)) {
      return ''
    } else {
      return item[1]
    }
  }

  const getSuitForNonSuit = (item) => {
    if (!nonSuitCardSelected && selectedCards.length > 0) {
      return ''
    }
    return item[1]
  }

  const canClickOnNonSuit = (item) => {
    if (!nonSuitCardSelected && selectedCards.length > 0) {
      return false
    }
    return true
  }

  return (
    <div>
      <div className={styles.cards}>
        {
          sortCards(firstComb, false).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={getSuit(item)}
              value={item[0]}
              size='xs'
              handleClick={() => cardIsSelected(item) ? '' : setSelectedCards(item[0] + item[1])}
              preventSelection
            />

          ))
        }
      </div>
      <div className={styles.cards}>
        {
          sortCards(secondComb, false).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={getSuit(item)}
              value={item[0]}
              size='xs'
              handleClick={() => cardIsSelected(item) ? '' : setSelectedCards(item[0] + item[1])}
              preventSelection
            />

          ))
        }
      </div>
      <div className={styles.cards}>
        {
          sortCards(thirdComb, false).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={getSuit(item)}
              value={item[0]}
              size='xs'
              handleClick={() => cardIsSelected(item) ? '' : setSelectedCards(item[0] + item[1])}
              preventSelection
            />

          ))
        }
      </div>
      <div className={styles.cards}>
        {
          sortCards(fourthComb, false).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={getSuit(item)}
              value={item[0]}
              size='xs'
              handleClick={() => cardIsSelected(item) ? '' : setSelectedCards(item[0] + item[1])}
              preventSelection
            />

          ))
        }
      </div>
      <div className={styles.cards}>
        {
          sortCards(fifthComb, false).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={getSuitForNonSuit(item)}
              value={item[0]}
              size='xs'
              handleClick={() => canClickOnNonSuit(item) ? setSelectedCards(item[0] + item[1]) : ''}
              specialSuit
              lightCard
              preventSelection
            />

          ))
        }
      </div>
      <div className={styles.selectedCardsRow}>
        <div className={styles.selectedCardsButtonSlot} aria-hidden="true" />
        <div className={styles.selectedCards}>
          <PlayingCard
            suit={selectedCards.length >= 1 ? getXSuit(selectedCards[0]) : ''}
            value={selectedCards.length >= 1 ? selectedCards[0][0] : ''}
            handleClick={() => setSelectedCards('', true, 0)}
            customColor={customColor()}
            specialSuit={nonSuitCardSelected}
            preventSelection
            heroCard={selectedCards.length >= 1 ? true : false}
            heroColor={selectedCards.length >= 1 ? heroColor : 'default'}
          />
          <PlayingCard
            suit={selectedCards.length >= 2 ? getXSuit(selectedCards[1]) : ''}
            value={selectedCards.length >= 2 ? selectedCards[1][0] : ''}
            handleClick={() => setSelectedCards('', true, 1)}
            customColor={customColor()}
            specialSuit={nonSuitCardSelected}
            preventSelection
            heroCard={selectedCards.length >= 2 ? true : false}
            heroColor={selectedCards.length >= 2 ? heroColor : 'default'}
          />
          <PlayingCard
            suit={selectedCards.length >= 3 ? getXSuit(selectedCards[2]) : ''}
            value={selectedCards.length >= 3 ? selectedCards[2][0] : ''}
            handleClick={() => setSelectedCards('', true, 2)}
            customColor={customColor()}
            specialSuit={nonSuitCardSelected}
            preventSelection
            heroCard={selectedCards.length >= 3 ? true : false}
            heroColor={selectedCards.length >= 3 ? heroColor : 'default'}
          />
          <PlayingCard
            suit={selectedCards.length >= 4 ? getXSuit(selectedCards[3]) : ''}
            value={selectedCards.length >= 4 ? selectedCards[3][0] : ''}
            handleClick={() => setSelectedCards('', true, 3)}
            customColor={customColor()}
            specialSuit={nonSuitCardSelected}
            preventSelection
            heroCard={selectedCards.length >= 4 ? true : false}
            heroColor={selectedCards.length >= 4 ? heroColor : 'default'}
          />
          {
            isPlo5 && (
              <PlayingCard
                suit={selectedCards.length == 5 ? getXSuit(selectedCards[4]) : ''}
                value={selectedCards.length == 5 ? selectedCards[4][0] : ''}
                handleClick={() => setSelectedCards('', true, 4)}
                customColor={customColor()}
                specialSuit={nonSuitCardSelected}
                preventSelection
                heroCard={selectedCards.length >= 5 ? true : false}
                heroColor={selectedCards.length >= 5 ? heroColor : 'default'}
              />
            )
          }
        </div>
        {selectedCards.length === (isPlo5 ? 5 : 4) ? (
          <button
            type="button"
            className={styles.clearCardsButton}
            onClick={clearCards}
            aria-label="Clear cards"
            title="Clear cards"
          >
            <Icon icon="times" className={styles.clearCardsIcon} />
          </button>
        ) : (
          <div className={styles.selectedCardsButtonSlot} aria-hidden="true" />
        )}
      </div>
    </div>
  )
};

export default CardChooser;
